module.exports = __webpack_public_path__ + "static/media/valor2_4.b043b9d3.png";